module.exports = __webpack_public_path__ + "img/loader.1ae2e6c046ec9e88c1f4dd4c9a61e5c3.svg";